<template>
  <LayoutMinimal>
    <section
            id="payment_result"
    >
      <div class="content">
        <div class="title">
          <h3>
            <template v-if="loading || error">
              {{$t('payment_result.title')}}
            </template>
            <template v-else>
              <template v-if="payment.is_preapproval">
                {{$t('subscription_result.title')}}
              </template>
              <template v-else>
                {{$t('payment_result.title')}}
              </template>
            </template>
          </h3>
        </div>
        <template v-if="loading || error">
          <div class="loading-or-error">
            <Spinner v-if="loading"/>
            <p v-if="error">
              {{$t('error')}}
            </p>
          </div>
        </template>
        <template v-else>
            <PaymentStatus :payment="payment"/>
        </template>
        <div class="buttons">
          <template v-if="$auth.ready() && $auth.user().membership_active">
            <router-link class="btn main-btn" :to="{name: 'home'}">
              {{$t('back_to_home')}}
            </router-link>
          </template>
          <template v-else-if="claimsFailedCard">
            <!-- see status -->
          </template>
          <template v-else>
            <router-link class="btn main-btn" :to="{name: 'dashboard'}">
              {{$t('header.dashboard')}}
            </router-link>
          </template>
        </div>
      </div>
    </section>
    <template slot="after">
      <Footer/>
    </template>
  </LayoutMinimal>
</template>

<script>
import Spinner from "../components/Spinner";
import Footer from "../components/Footer";
import LayoutMinimal from "../layouts/LayoutMinimal";
import resources from '../resources';
import PaymentStatus from "../components/PaymentStatus";

export default {
      components: {
          PaymentStatus,
          Spinner,
          LayoutMinimal,
          Footer,
      },
      data(){
        return {
            loading: true,
            error: false,
            payment: null,
            intervalLoadPayment: null
        }
      },
      computed: {
          claimsSuccess(){
              return this.$route.query.success === '1';
          },
          claimsFailedCard(){
              return (this.payment &&
                  (this.payment.status === 'canceled' || this.payment.status === 'failed') &&
                  this.payment.data);
          },
      },
      methods:{
          loadPayment(id){
              this.error = false;
              this.loading = true;
              this.payment = null;

              resources.payments.get({
                  id,
                  include: ['user_credit_card']
              })
                  .then((payment) => {
                      this.payment = payment.data.data;
                      this.loading = false;

                      if(this.claimsSuccess){
                          this.payment.status = 'approved';
                      }
                  }).catch(() => {
                      this.loading = false;
                      this.error = true;
                  });
          },
      },
      watch: {

      },
      beforeRouteUpdate (to, from, next) {
          this.loadPayment(to.params.id);

          next();
      },
      mounted(){
        const paymentId = this.$route.query.id;

          if(this.$auth.check()){
            this.loadPayment(paymentId);
          }else{
            this.$router.push({
              name: 'login',
              query: {
                payment_id:  this.$route.query.id,
              }
            });
          }
          
          // si viene de ccbill => hago que revice el estado del pago
          // le meto un timeout por si el pago ya viene aprobado y no sea necesario revisar el pago
          let ccbillTimeout     = 3000;
          let ccbillIntervalTime= 5000;
          
          setTimeout(()=>{
              this.intervalLoadPayment = setInterval(()=> {
                  // console.log(this.payment.status);
                  (!this.claimsSuccess && this.payment && this.payment.status === 'pending')
                        ? this.loadPayment(paymentId)
                        : clearInterval(this.intervalLoadPayment);
              }, ccbillIntervalTime);
          },ccbillTimeout);
      },
    beforeDestroy() {
        clearInterval(this.intervalLoadPayment);
    }
}
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #payment_result {
    .title {
      text-align: center;

      & > * {
        display: inline-block;
        background-color: $pallete_main_color;
        color: #ffffff;
        font-weight: bolder;
        text-transform: uppercase;
        font-size: 1.5em;
        margin: 0;
        margin-bottom: 1em;
        padding: .25em;
        box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
      }
    }

    .buttons{
      display: block;
      height: auto;
      margin-top: 3em;
      text-align: center;

      .btn.main-btn{
        @extend %fresh-btn;
        padding: .5em;
      }
    }
  }
</style>